/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type BuildTooltip_build$ref = any;
export type BuildStates = "BLOCKED" | "CANCELED" | "CANCELING" | "FAILED" | "NOT_RUN" | "PASSED" | "RUNNING" | "SCHEDULED" | "SKIPPED" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type Bar_build$ref: FragmentReference;
export type Bar_build = {|
  +message: ?string,
  +branch: string,
  +commit: string,
  +state: BuildStates,
  +pipeline: {|
    +commitShortLength: number,
    +defaultBranch: ?string,
  |},
  +$fragmentRefs: BuildTooltip_build$ref,
  +$refType: Bar_build$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "Bar_build",
  "type": "Build",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "message",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "branch",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "commit",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "state",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pipeline",
      "storageKey": null,
      "args": null,
      "concreteType": "Pipeline",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "commitShortLength",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "defaultBranch",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "BuildTooltip_build",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6f98f8e19fa7cad460bc86208a00cb81';
module.exports = node;
